import { createRoot } from 'react-dom/client'
import './index.css'
import { BrowserRouter } from "react-router";
import ScaenaRouter from './utils/Routes.tsx';
import { HelmetProvider } from 'react-helmet-async';
import MobileStoreFrame from './app/MobileStoreFrame.tsx';
import StorefrontFrame from './app/StorefrontFrame.tsx';
import RouteScrollRestoration from './app/RouteScrollRestoration.tsx';
import { CsspSearchCacheLifecycle } from './app/CsspSearchCacheLifecycle.tsx';
import { CsspSuppliersProvider } from './features/cssp/CsspSuppliersProvider.tsx';
createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
  <BrowserRouter>
   <CsspSuppliersProvider>
    <RouteScrollRestoration />
    <CsspSearchCacheLifecycle />
    <MobileStoreFrame>
     <StorefrontFrame>
       <ScaenaRouter></ScaenaRouter>
     </StorefrontFrame>
    </MobileStoreFrame>
   </CsspSuppliersProvider>
  </BrowserRouter>    
  </HelmetProvider>
,
)
